<app-loader-circles *ngIf="showLoader"></app-loader-circles>

<div class="row">
  <form [formGroup]="dadosClienteForm" class="col-xs-12 forms">
    <div class="info-container">
      <h2>Informações do Cliente</h2>

      <div class="form-group">
        <span class="icon documento"></span>

        <div class="inputs">
          <div class="box-label">
            <label for="cpf">CPF do Cliente</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe o CPF do cliente, contendo 11 números. Não é necessário inclusão de pontos ou traço."
            ></saiba-mais>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            required
            mask-number
            mask="999.999.999-99"
            appCpfValidator
            appShowErrorMessages
            requiredMessage="O campo CPF é obrigatório"
            formControlName="cpf"
            name="cpf"
            (blur)="onCpfChange()"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon vazio"></span>

        <div class="inputs">
          <div class="box-label">
            <label for="dataNascimento">Data de Nascimento</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe a data de nascimento do cliente, através de números do formato DD/MM/AAAA."
            ></saiba-mais>
          </div>

          <input
            class="form-control"
            type="text"
            mask-number
            mask="99/99/9999"
            placeholder="00/00/0000"
            required
            appDataValidator
            [dateRange]="dataRange"
            appShowErrorMessages
            requiredMessage="O campo Data de Nascimento é obrigatório"
            formControlName="dataNascimento"
            name="dataNascimento"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon classe-profissional"></span>

        <div class="inputs">
          <div class="box-label">
            <label for="classeProfissional">Classe Profissional</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe a classe profissional que o cliente possui."
            ></saiba-mais>
          </div>

          <select
            class="form-control"
            required
            appShowErrorMessages
            requiredMessage="O campo Classe Profissional é obrigatório"
            name="classeProfissional"
            formControlName="classeProfissional"
          >
            <option value="" selected hidden>Selecione...</option>

            <option
              *ngFor="let classe of classesProfissionais"
              value="{{ classe.id }}"
            >
              {{ classe.descricao }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="dadosConjugeForm" class="col-xs-12 forms">
    <div class="info-container blue-box" *ngIf="showConjugeSubject.value">
      <h2>Informações do Cônjuge</h2>

      <div class="form-group">
        <span class="icon documento"></span>
        <div class="inputs">
          <div class="box-label">
            <label for="cpfConjuge">CPF</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe o CPF do cônjuge, contendo 11 números. Não é necessário inclusão de pontos ou traço."
            ></saiba-mais>
          </div>
          <input
            class="form-control"
            type="text"
            placeholder="000.000.000-00"
            required
            mask-number
            mask="999.999.999-99"
            appCpfValidator
            appShowErrorMessages
            requiredMessage="O campo CPF é obrigatório"
            requiredMessage="O campo CPF é obrigatório"
            formControlName="cpfConjuge"
            name="cpfConjuge"
            customErrorMessage="O CPF do cônjuge não pode ser o mesmo do cliente"
          />
        </div>
      </div>

      <div class="form-group mb-0">
        <span class="icon conjuge"></span>

        <div class="inputs">
          <div class="box-label">
            <label for="dataNascimentoConjuge">Data de Nascimento</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe a data de nascimento do cliente, através de números do formato DD/MM/AAAA."
            ></saiba-mais>
          </div>

          <input
            class="form-control"
            type="text"
            mask-number
            mask="99/99/9999"
            placeholder="00/00/0000"
            required
            appDataValidator
            [dateRange]="dataRange"
            appShowErrorMessages
            requiredMessage="O campo Data de Nascimento é obrigatório"
            formControlName="dataNascimentoConjuge"
            name="dataNascimentoConjuge"
          />
        </div>
      </div>
    </div>
  </form>

  <form [formGroup]="rendaForm" class="col-xs-12 forms">
    <div class="info-container">
      <div id="renda-container" class="form-group">
        <span class="icon dinheiro"></span>
        <div class="inputs">
          <div class="box-label">
            <label for="renda">Renda</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              [texto]="
                'Informe a renda que o cliente possui. Lembre-se que pode ser solicitado comprovação desta renda. ' +
                'Para rendas não comprovadas, não esqueça de marcar o campo Renda Atribuída.'
              "
            ></saiba-mais>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            required
            [maxLength]="15"
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            requiredMessage="O campo Renda é obrigatório"
            formControlName="renda"
            name="renda"
            mask-money
            prefix="R$"
            appMoedaValidator
            valorMinimoMessage="Valor mínimo permitido R$"
            appOnlyNumberRestrictive
            [valorRendaMinima]="this.parametroRendaProduto.valorRendaMinima"
          />
        </div>
      </div>
    </div>

    <div class="info-container">
      <div class="form-group">
        <span class="icon dinheiro"></span>

        <div class="inputs">
          <div class="box-label">
            <label for="valorSolicitado">Valor Solicitado</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe o valor do financiamento, de acordo com a mercadoria ou soma das mercadorias escolhido pelo cliente."
            >
            </saiba-mais>
          </div>

          <input
            class="form-control"
            type="text"
            placeholder="R$ 00.000,00"
            [maxLength]="15"
            required
            appOnlyDigitsLengthValidator
            appShowErrorMessages
            requiredMessage="O campo Valor solicitado é obrigatório"
            formControlName="valorSolicitado"
            name="valorSolicitado"
            mask-money
            prefix="R$"
            appMoedaValidator
            valorMinimoMessage="Valor mínimo permitido R$"
            appOnlyNumberRestrictive
            [valorMinimo]="this.parametroRendaProduto.valorSolicitadoMinimo"
            [valorMaximo]="this.parametroRendaProduto.valorSolicitadoMaximo"
          />
        </div>
      </div>

      <div class="form-group">
        <span class="icon cdc-loja"></span>

        <div class="inputs" [formGroup]="principalForm">
          <div class="box-label">
            <label for="tabela">Tabela</label>

            <saiba-mais
              [isPopoverOnHover]="true"
              [isPositionStatic]="true"
              [isSmall]="true"
              texto="Informe a tabela de juros disponível para o lojista."
            ></saiba-mais>
          </div>

          <select
            class="form-control"
            appShowErrorMessages
            requiredMessage="O campo tabela é obrigatório"
            formControlName="tabela"
            name="tabela"
          >
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let tabela of tabelas" value="{{ tabela.id }}">
              {{ tabela.descricao }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="info-container mb-0">
      <app-endereco-base
        [enderecoForm]="enderecosForm"
        tipoEndereco="residencial"
      ></app-endereco-base>
    </div>
  </form>

  <footer class="footer-cdc">
    <app-botao-navegacao-clean
      (previous)="onClickPrevious()"
      (next)="onClickNext()"
      [previousShow]="true"
      [nextShow]="true"
      [nextEnabled]="formValid"
    ></app-botao-navegacao-clean>
  </footer>
</div>
